<template>
  <div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('dashboard')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{__('Dashboard')}}</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="$page.props.auth.user.owner">
      <inertia-link class="flex items-center group py-3" :href="route('organizations')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('organizations') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('organizations') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{__('Customers')}}</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="$page.props.auth.user.owner || $page.props.auth.user.customer_id > 0">
      <inertia-link class="flex items-center group py-3" :href="route('contacts')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('contacts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('contacts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{__('Users')}}</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="$page.props.auth.user.owner || $page.props.auth.user.customer_id > 0">
      <inertia-link class="flex items-center group py-3" :href="route('label-list')">
        <icon name="labels" class="w-4 h-4 mr-2" :class="isUrl('labels') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('labels') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{__('Products')}}</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('orders')">
        <icon name="printer" class="w-4 h-4 mr-2" :class="isUrl('orders') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('orders') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{__('Orders')}}</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="!$page.props.auth.user.owner &&  $page.props.auth.user.contact_id > 0">
      <inertia-link class="flex items-center group py-3" :href="route('orders.create')">
        <icon name="plus" class="w-4 h-4 mr-2" :class="isUrl('orders/create') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('orders/create') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{__('New Order')}}</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="$page.props.auth.user.owner">
      <inertia-link class="flex items-center group py-3" :href="route('reports')">
        <icon name="printer" class="w-4 h-4 mr-2" :class="isUrl('reports') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('reports') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{__('Reports')}}</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="$page.props.auth.user.owner">
      <inertia-link class="flex items-center group py-3" :href="route('creditnotes')">
        <icon name="printer" class="w-4 h-4 mr-2" :class="isUrl('creditnotes') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('creditnotes') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{__('Credit Notes')}}</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('download')">
        <icon name="download" class="w-4 h-4 mr-2" :class="isUrl('download') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('download') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{__('Downloads LCD')}}</div>
      </inertia-link>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
